module.exports = __webpack_public_path__ + "static/media/transaccionesPendientes.04017dc5.svg";